<template>
  <div>
    <vue-dropzone
      v-if="!isUploading && !isSuccess"
      id="image-dropzone"
      :options="options"
      @vdropzone-file-added="triggerUploadFile"
    />

    <b-alert v-else-if="isUploading && !isSuccess" variant="primary" show>
      <p>Your file is currently uploading. Please wait.</p>
    </b-alert>

    <b-alert v-else variant="success" show><p>Your file has been uploaded with success.</p></b-alert>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { UPLOAD_FILE } from "@/store/actions";

import VueDropzone from "vue2-dropzone";
import { BAlert } from "bootstrap-vue";

export default {
  name: "Upload",
  components: { VueDropzone, BAlert },
  props: {
    type: {
      type: String,
      default: "files",
    },
  },
  data: () => ({
    options: { url: "https://cdn.purplewave.ai" },

    isUploading: false,
    isSuccess: false,
  }),
  methods: {
    ...mapActions("files", { uploadFile: UPLOAD_FILE }),
    async triggerUploadFile(file) {
      const { type } = this;
      this.isUploading = true;

      const result = await this.uploadFile({ type, file });

      this.isSuccess = true;
      this.isUploading = false;

      this.$emit("success", { ...result });
    },
  },
};
</script>

<style lang="scss" scoped>
#image-dropzone {
  ::v-deep .dz-default {
    text-align: center;
    margin: 0;
  }
}
</style>
